"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProbabilities = exports.groupByOutcomeTypeId = void 0;
const hasShortName_1 = require("../hasShortName");
const getEventProbabilityOutcomeNameV3_1 = require("../getEventProbabilityOutcomeNameV3");
const sortProbabilities_1 = require("./sortProbabilities");
const groupByOutcomeTypeId = (probabilities) => {
    return probabilities.reduce((acc, cur) => {
        if (acc[cur.outcomeTypeId] === undefined) {
            acc[cur.outcomeTypeId] = [];
        }
        acc[cur.outcomeTypeId].push(cur);
        return acc;
    }, {});
};
exports.groupByOutcomeTypeId = groupByOutcomeTypeId;
const getProbabilities = (probabilities, market, outcomeTypes, outcomesTypesMap, players, eventCompetitors, clientType) => {
    const isShortNamed = (0, hasShortName_1.hasShortName)(market, clientType);
    const templateId = market.outcomesGroup.renderTemplateId;
    const probsByOutcomeType = (0, exports.groupByOutcomeTypeId)(probabilities);
    const { orderedBy } = market.outcomesGroup;
    let orderedOutcomeTypeIds = [];
    if (orderedBy === null || orderedBy === void 0 ? void 0 : orderedBy.orderedOutcomeTypeIds) {
        orderedOutcomeTypeIds = [...orderedBy.orderedOutcomeTypeIds];
    }
    if (orderedOutcomeTypeIds.length === 0) {
        orderedOutcomeTypeIds = outcomeTypes.map(({ id }) => id);
    }
    else {
        outcomeTypes.forEach((outcomeType) => {
            if (!orderedOutcomeTypeIds.includes(outcomeType.id)) {
                orderedOutcomeTypeIds.push(outcomeType.id);
            }
        });
    }
    return orderedOutcomeTypeIds.flatMap((outcomeTypeId) => {
        const outcomeType = outcomesTypesMap[outcomeTypeId];
        const probs = probsByOutcomeType[outcomeTypeId] || [];
        (0, sortProbabilities_1.sortProbabilities)(probs, outcomeTypeId, orderedBy);
        return probs.map((eventProbability) => {
            const name = (0, getEventProbabilityOutcomeNameV3_1.getEventProbabilityOutcomeNameV3)({
                eventProbability,
                market,
                players,
                templateId,
                outcomeType,
                eventCompetitors,
                isShortNamed,
            });
            const probability = {
                ...eventProbability,
                outcomeTypeData: {
                    ...outcomeType,
                    name,
                },
            };
            return probability;
        });
    });
};
exports.getProbabilities = getProbabilities;
//# sourceMappingURL=getProbabilities.js.map